import { reduce, isEqual } from 'lodash'

export default {
  methods: {
    /**
     *
     * @param {Object} objectA objeto para comparar
     * @param {Object} objectB outro objeto para comparar
     *
     * @returns {Boolean} 'True' quando houver diferença nos objetos e 'False' quando não houver
     */
    getDiffInObjects(objectA, objectB) {
      const diff = reduce(
        objectA,
        (result, value, key) => {
          return isEqual(value, objectB[key]) ? result : result.concat(key)
        },
        []
      )

      return Boolean(diff.length)
    }
  }
}
